import { render, staticRenderFns } from "./choice_subject.vue?vue&type=template&id=a18360a6&"
import script from "./choice_subject.vue?vue&type=script&lang=js&"
export * from "./choice_subject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports